import { render, staticRenderFns } from "./ExhibitionNew.vue?vue&type=template&id=88cbb5d8"
import script from "./ExhibitionNew.vue?vue&type=script&lang=js"
export * from "./ExhibitionNew.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionNew.vue?vue&type=style&index=0&id=88cbb5d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports